import { render, staticRenderFns } from "./ConfirmSelection.vue?vue&type=template&id=7f22145a&scoped=true"
import script from "./ConfirmSelection.vue?vue&type=script&lang=js"
export * from "./ConfirmSelection.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSelection.vue?vue&type=style&index=0&id=7f22145a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f22145a",
  null
  
)

export default component.exports